import cn from 'classnames';
import React from 'react';
import Drawer from '../../ui/drawer';
import ShareDesign from './components/share-mockup';
import classes from './share-mockup-design-popup.scss';
export default function ShareMockupDesignPopup({
  onClose,
  open,
  isLimitedEdition
}) {
  return /*#__PURE__*/React.createElement(Drawer, {
    prerenderForCrawlers: true,
    dataDrawer: "ShareDesign",
    open: open,
    onClose: onClose,
    closeClassName: cn(classes.closeClassName, {
      [classes.orangeBackground]: isLimitedEdition
    }),
    headerTitle: "Share your design",
    paperClassName: classes.paper,
    headerClassName: classes.headerClassName,
    bodyClassName: classes.bodyClassName
  }, /*#__PURE__*/React.createElement(ShareDesign, {
    isLimitedEdition: isLimitedEdition
  }));
}